import React from "react";
import "./Desarrollo.css";
import TarjetaDeServicioDesarrollo from "./components/TarjetaDeServicioDesarrollo";
import GestionDesarrollo from "./components/GestionDesarrollo";
import { useTranslation } from "react-i18next";

interface ServiceItem {
  title: string;
  desc: string;
}

export default function Desarrollo() {
  const { t } = useTranslation();

  const services: ServiceItem[] = [
    {
      title: t("pages.desarrollo.services.0.title"),
      desc: t("pages.desarrollo.services.0.desc"),
    },
    {
      title: t("pages.desarrollo.services.1.title"),
      desc: t("pages.desarrollo.services.1.desc"),
    },
    {
      title: t("pages.desarrollo.services.2.title"),
      desc: t("pages.desarrollo.services.2.desc"),
    },
  ];

  return (
    <>
      <div
        className="fondo-desarrollo-container"
        style={{ backgroundImage: 'url("/Desarrollo.webp")' } as React.CSSProperties}
      >
        <div className="desarrollo-overlay">
          <h1>{t("pages.desarrollo.title")}</h1>
          <p>{t("pages.desarrollo.description")}</p>
        </div>
      </div>

      <h2 className="beneficios-titulo">
        {t("pages.desarrollo.benefits_title")}
      </h2>

      <div className="card-grid">
        {services.map((s) => (
          <TarjetaDeServicioDesarrollo
            key={s.title}
            service={s}
            animationClass="from-bottom"
          />
        ))}
      </div>

      <GestionDesarrollo
        gestion={[
          {
            imagen: "/empresa1.webp",
            descripcion: t("pages.desarrollo.gestion.0.descripcion"),
          },
        ]}
        alcance={[
          {
            imagen: "/consultoria.webp",
            descripcion: t("pages.desarrollo.alcance.0.descripcion"),
          },
        ]}
      />
    </>
  );
}
